const routes =[
  {
    path: '/app/myApp/index',
    name: 'myApp',
    meta: {
      title: '我的应用',
    },
    component: () => import('@/views/app/myApp/index'),
  },
  {
    path: '/app/market/index',
    name: 'appMarket',
    meta: {
      title: '应用市场',
    },
    component: () => import('@/views/app/market/index'),
  },
  {
    path: '/app/market/list',
    name: 'appList',
    meta: {
      title: '',
    },
    component: () => import('@/views/app/market/list'),
  },
  {
    path: '/app/appDetail/index',
    name: 'appDetail',
    meta: {
      title: '应用详情',
      isfromRedirectUrl: true,// 登录成功之后是否跳转到当前页面
    },
    component: () => import('@/views/app/appDetail/index'),
  },
  {
    path: '/app/order/index',
    name: 'appOrder',
    meta: {
      title: '应用订购详情',
      checkLogin: true,
    },
    component: () => import('@/views/app/order/index'),
  },
  {
    path: '/app/order/Detail',
    name: 'appOrderDetail',
    meta: {
      title: '订购详情',
    },
    component: () => import('@/views/app/order/Detail'),
  },
  {
    path: '/app/orderRecord/index',
    name: 'orderRecord',
    meta: {
      title: '订购记录',
    },
    component: () => import('@/views/app/orderRecord/index'),
  },
  {
    path: '/app/orderRecord/Detail',
    name: 'orderRecordDetail',
    meta: {
      title: '订购记录详情',
    },
    component: () => import('@/views/app/orderRecord/Detail'),
  },
];

export default [
  {
    path: '/main/Layout',
    component: () => import('@/views/main/Layout.vue'),
    children: [
      ...routes,
    ],
  },
];
